import { connect } from 'react-redux';
import Top100 from '../components/Top100Component';
import { getListMusicsIfNeeded } from '../actions/Top100Actions';


const mapStateToProps = (state) => ({
    listYears: state.top100.listYears,
    listMusics: state.top100.listMusics,
    notFound: state.top100.notFound,
});

const mapDispatchToProps = (dispatch) => ({
    getListMusicsIfNeeded: (year) => {
        dispatch(getListMusicsIfNeeded(year));
    },
});


const Top100Container = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Top100);

export default Top100Container;
